"use client";
import {
  useMenubarStore
} from "./E5PXVSMA.js";
import {
  MenubarContextProvider
} from "./WSQNIDGC.js";

// src/menubar/menubar-provider.tsx
import { jsx } from "react/jsx-runtime";
function MenubarProvider(props = {}) {
  const store = useMenubarStore(props);
  return /* @__PURE__ */ jsx(MenubarContextProvider, { value: store, children: props.children });
}

export {
  MenubarProvider
};
